import { useQuery } from "@tanstack/react-query";

import { TestCasesListResponse } from "@oracus/shared/api/test-cases";

import { apiClient } from "./client.ts";

export function useTestCases(limit = 100) {
  return useQuery({
    queryKey: ["test-cases", limit],
    queryFn: () =>
      apiClient.get(
        `/api/test-cases?limit=${limit}`,
        TestCasesListResponse,
      ),
  });
}
